/**
 * Created by mugambi on 25/03/17.
 */

export const getReceipts = state => state.receipts



// WEBPACK FOOTER //
// ./client/store/modules/receipts/getters.js